import {graphql} from 'react-relay'

export const buildArtifactsQuery = graphql`
  query BuildArtifactsQuery($buildLocator: String!) {
    build(buildLocator: $buildLocator) {
      id
      state
      artifacts {
        count
      }
    }
  }
`
